import { AlertMessage, ConfigurableText } from '@/app/components'

interface SaveMoneyAlertProps {
  costCategoryOptimizationEnabledMessage: string
}

export default function SaveMoneyAlert({
  costCategoryOptimizationEnabledMessage,
}: SaveMoneyAlertProps) {
  return (
    <AlertMessage variant="info">
      <ConfigurableText
        variant="body2"
        className="text-optiwatt-blue-500"
        config={costCategoryOptimizationEnabledMessage}
      />
    </AlertMessage>
  )
}
